var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.root] = true, _obj[_vm.$style.active] = _vm.state, _obj ),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.onClick.apply(null, arguments)}}},[_c('div',{class:_vm.$style.draggable,style:({
      transform: ("translateX(" + _vm.xPosition + ")")
    }),on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }